import { render, staticRenderFns } from "./TruckAssigments.vue?vue&type=template&id=7d77db3c&"
import script from "./TruckAssigments.vue?vue&type=script&lang=js&"
export * from "./TruckAssigments.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports